import { useSearchParams, Link } from "react-router-dom";
import { Seo } from "@/lib/seo";
import { ExternalLink, Info } from "lucide-react";

export default function OutboundPage() {
  const [params] = useSearchParams();
  const product = params.get("product") || "hotels";
  const subid = params.get("subid") || "";

  return (
    <>
      <Seo title="Outbound link — Hotelstrips" description="Affiliate booking link" path="/outbound" noindex />
      <div className="mx-auto max-w-2xl px-5 sm:px-8 py-24 text-center">
        <span className="grid h-14 w-14 mx-auto place-items-center rounded-full bg-primary/10 text-primary mb-6"><ExternalLink className="h-6 w-6" /></span>
        <h1 className="font-heading text-3xl font-black tracking-tighter text-ink">This link isn't available yet</h1>
        <p className="text-muted-foreground mt-4 leading-relaxed">
          This <span className="font-semibold text-ink">{product}</span> option isn't connected to a booking
          partner right now, so there's nothing to complete here. Explore GameDay to plan where to stay —
          hotels and flights are ready to book.
        </p>
        <div className="mt-6 inline-flex items-start gap-2 rounded-xl bg-muted/60 p-4 text-left text-xs text-muted-foreground">
          <Info className="h-4 w-4 mt-0.5 shrink-0" />
          <span>Tracking SubID: <code className="text-ink font-semibold">{subid || "—"}</code></span>
        </div>
        <div className="mt-8">
          <Link to="/gameday" className="inline-flex items-center rounded-full bg-ink px-6 py-3 text-sm font-heading font-bold text-white transition-transform hover:-translate-y-0.5">
            Back to GameDay
          </Link>
        </div>
        <p className="mt-8 text-xs text-muted-foreground">
          Hotelstrips may earn compensation when you book through certain links. <Link to="/affiliate-disclosure" className="underline">Affiliate disclosure</Link>.
        </p>
      </div>
    </>
  );
}
